import { createFeature, createReducer, on } from '@ngrx/store';
import { SchemaSidProperty } from '@qtek/shared/models';
import { SchemaActions } from './product-schemas.actions';

export interface SchemasState {
  productSchemaViews: { [key: string]: any };
  schemasSid: { [key: string]: SchemaSidProperty[] };
}

function getLocalStorageSids(): { [key: string]: SchemaSidProperty[] } {
  const localStorageSids = localStorage.getItem('schemaSids');
  return localStorageSids ? JSON.parse(localStorageSids) : {};
}

function updateLocalStorageSids(sids: { [key: string]: SchemaSidProperty[] }) {
  return localStorage.setItem('schemaSids', JSON.stringify(sids));
}

const initialState: SchemasState = {
  productSchemaViews: {},
  schemasSid: {},
};

export const productSchemasReducer = createReducer(
  initialState,

  on(SchemaActions.getProductSchemaByQuerySuccess, (state, { payload }) => ({
    ...state,
    productSchemaViews: {
      ...state.productSchemaViews,
      [payload.query]: payload.view,
    },
  })),
  on(SchemaActions.getSIDSchemaSuccess, (state, { payload }) => {
    const newSchemasSid = { ...state.schemasSid, ...payload };
    // updateLocalStorageSids(newSchemasSid); // Uncomment if using local storage
    return {
      ...state,
      schemasSid: newSchemasSid,
    };
  })
);

export const ProductSchemasFeature = createFeature({
  name: 'productSchemas',
  reducer: productSchemasReducer,
});

export const { selectProductSchemaViews, selectSchemasSid } =
  ProductSchemasFeature;
